import React from 'react';
import { useRouter } from 'next/router';
import { MdOutlineRocketLaunch, MdSettings } from 'react-icons/md';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import ScreenBottomBar from 'legacy/components/ScreenBottomBar';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

import { useOrganization } from '../../../../context/EditOrganizationProvider';

const BottomBar = () => {
  const { t } = useTranslation(['organizations']);
  const { submitForm, errors } = useFormikContext();
  const { data } = useOrganization();
  const router = useRouter();

  const goToSettings = () => {
    router.push(
      data.isEditing
        ? `/organizations/${data.organization.id}/edit/settings`
        : '/organizations/create/settings'
    );
  };

  return (
    <ScreenBottomBar
      aboveContent={
        <div className="bg-primary-800">
          <Button
            type={ButtonType.LargeCta}
            isSubmit
            onClick={submitForm}
            loading={data.isSubmitting}
            disabled={Object.keys(errors).length > 0}
          >
            {!data.isEditing ? t('actions.create') : t('actions.save')}
            <MdOutlineRocketLaunch size={20} />
          </Button>
        </div>
      }
    >
      <div className="flex w-full justify-center items-center">
        <Button
          onClick={goToSettings}
          type={ButtonType.Inverted}
          autoWidth
          disabled={data.isSubmitting}
          icon={<MdSettings size={20} />}
        >
          {t('navigation.settings')}
        </Button>
      </div>
    </ScreenBottomBar>
  );
};

export default BottomBar;
